import { Box, Typography, Button, Grid2, DialogTitle } from '@mui/material'
import React from 'react'

export default function FormTemplate({ children, title, handleSubmit, isValid, onClose }) {
    return (
        <Box
            sx={{
                height: '100%',
                borderRadius: 2,
                width: "100%",
                minWidth: '1000',
                minHeight: '400',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                maxHeight: '100%',
                bgcolor: 'background.paper',
                color: 'text.primary',
            }}
            fullWidth={true}
        >
            <DialogTitle sx={{ flexShrink: 0, bgcolor: 'background.default' }} color='companyBlue'>
                {title}
            </DialogTitle>

            <Box
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    color: 'text.primary',
                    bgcolor: 'background.paper',
                }}
            >
                <Box justifyContent='left' display='flex'
                >
                    <Grid2 container direction='row' justifyContent='left' spacing={0} sx={{ p: 2, maxWidth: '100%' }}
                    >
                        {children}
                    </Grid2>
                </Box>
            </Box>

            <Box
                justifyContent='left'
                display='flex'
                sx={{
                    flexShrink: 0,
                    mt: 'auto',
                    mb: 1,
                    pl: 2,
                    pr: 2,
                    bgcolor: 'background.paper'
                }}
            >
                <Grid2
                    container
                    justifyContent='center'
                    spacing={2}
                    sx={{
                        maxWidth: '25rem',
                    }}

                >
                    <Grid2 item>
                        <Button
                            onClick={handleSubmit}
                            color='companyBlue'
                            aria-label='submit'
                            variant='contained'
                            disabled={!isValid}
                            sx={{
                                borderRadius: '50px', // Ensures a "pill" shape
                                padding: '8px 24px',  // Adjust for desired size
                                height: '40px',       // Fixed height for consistent shape
                                textTransform: 'none', // Optional: Prevents all-uppercase text
                            }}
                        >
                            <Typography color='text.primary'>
                                Submit
                            </Typography>
                        </Button>
                    </Grid2>
                    <Grid2 item>
                        <Button
                            variant="outlined"
                            onClick={onClose}
                            sx={{
                                borderRadius: '50px', // Ensures a "pill" shape
                                padding: '8px 24px',  // Adjust for desired size
                                height: '40px',       // Fixed height for consistent shape
                                textTransform: 'none', // Optional: Prevents all-uppercase text
                            }}
                        >
                            <Typography color='text.primary'>
                                Cancel
                            </Typography>
                        </Button>
                    </Grid2>
                </Grid2>
            </Box>
        </Box>
    )
}